import { getUserInfoSessionData } from './sessionUtil';

export function createActivity(activityData: any) {
  const userInfoData = getUserInfoSessionData();

  if (
    !activityData.EmailAddress &&
    typeof window !== 'undefined' &&
    userInfoData
  ) {
    const phone = userInfoData.phoneNumber || '';
    activityData.EmailAddress = userInfoData.email || '';
    if (phone && !activityData.Phone) {
      activityData.Phone = phone;
    }
  }

  if (!activityData.EmailAddress) {
    return new Promise((resolve: any) => resolve()).catch(err => {
      throw err;
    });
  }

  return new Promise((resolve: any) => {
    fetch('/save/leadsvc/activity/V2?leadType=SAVE', {
      method: 'POST',
      body: JSON.stringify(activityData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(
        (res: any) => resolve(res),
        (err: any) => resolve(err)
      )
      .catch(err => {
        throw err;
      });
  });
}

export function createLeadGeneric(
  email: string,
  customLeadData: any
): Promise<Response> {
  const leadData = {
    leadType: 'SAVE',
    leadEmail: email,
    note: 'Clearsave lead',
    leadName: email,
    leadSourcePage: location.pathname + location.search,
    leadSourceUrl: window.location.href,
    leadCreationTime: String(Date.now()),
    customAttributesMap: customLeadData,
    ...customLeadData,
  };

  return fetch('/save/leadsvc/lead', {
    method: 'POST',
    body: JSON.stringify(leadData),
    headers: { 'Content-Type': 'application/json' },
  });
}



// WEBPACK FOOTER //
// ./utils/leadUtils.ts